import * as React from 'react';
import magnifyingGlass from 'assets/images/search-modal-magnifying-glass.svg';
import { useIntl } from 'react-intl-next';
import { Root, Img, MessageTitle, HelperText } from '../common/styled';
import messages from './messages';

export const SearchResultNone = ({ term }: { term: string }) => {
    const { formatMessage } = useIntl();

    return (
        <Root>
            <Img src={magnifyingGlass} />
            <MessageTitle>{formatMessage(messages.noSearchResultTitle)}</MessageTitle>
            <HelperText>{formatMessage(messages.noSearchResultText, { term })}</HelperText>
        </Root>
    );
};
